import { useEffect, useState } from "preact/hooks";
import { venueSwitchBlock, initStore } from "../state/store.js";
import { localOnline, cloudOnline, lastError } from "../state/sync.js";

/**
 * Vollbild-Sperre bei Venue-Wechsel mit noch nicht gesendeten Bons der vorigen
 * Veranstaltung. Verhindert, dass diese an die neue Venue fehlgeleitet werden.
 * Drained automatisch nach (alle 5 s) und reagiert auf "wieder online".
 */
export function VenueSwitchBlock() {
  const block = venueSwitchBlock.value;
  const [busy, setBusy] = useState(false);

  async function retry() {
    if (busy) return;
    setBusy(true);
    try {
      // initStore() → reconcileVenue() drained die Outbox mit der ALTEN Venue-Identität
      // und löst den Block bei Erfolg auf. Kein eigenes flush() hier (nutzt die neue Venue).
      await initStore();
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => {
    const id = window.setInterval(() => void retry(), 5000);
    const onOnline = () => void retry();
    window.addEventListener("online", onOnline);
    return () => {
      window.clearInterval(id);
      window.removeEventListener("online", onOnline);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!block) return null;

  return (
    <div class="app">
      <main class="main">
        <div class="empty">
          <h2>Vorige Veranstaltung noch nicht abgeschlossen</h2>
          <p>
            Es {block.count === 1 ? "ist 1 Bestellung" : `sind ${block.count} Bestellungen`} der
            vorigen Veranstaltung noch <strong>nicht gesendet</strong>.
          </p>
          <p>
            Bitte das Gerät ins WLAN des vorigen Servers oder ins Internet bringen — sobald die
            Bestellungen oben angekommen sind, wird automatisch auf die neue Veranstaltung
            umgestellt.
          </p>
          <p>
            Verbindung: lokal {localOnline.value ? "● erreichbar" : "○ weg"} · Cloud{" "}
            {cloudOnline.value ? "● erreichbar" : "○ weg"}
          </p>
          {/* Der eigentliche Grund: Erreichbarkeit (/api/health) und Senden (POST /api/events)
              können auseinanderlaufen — daher den konkreten Fehler des letzten Sendeversuchs zeigen. */}
          {lastError.value ? (
            <p class="login-error">Senden fehlgeschlagen: {lastError.value}</p>
          ) : busy ? (
            <p>Sende…</p>
          ) : null}
          <button class="btn-primary" disabled={busy} onClick={() => void retry()}>
            {busy ? "Sende…" : "Erneut versuchen"}
          </button>
        </div>
      </main>
    </div>
  );
}
